import { useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";

import { authHttpClient } from "@/lib/http";
import { storage } from "@/lib/storage";

export function useSignOut() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      const path = "auth/logout";
      await authHttpClient.post(path);
    },
    // Let's sign the user out on the client side even if the server fails.
    onSettled: () => {
      storage.clear();
      void navigate("/sign-in");
    },
  });
}
